import React from 'react';

import Layout from '../../Layout/index';
import NewsList from '../../NewsList/index';


const Politics = () => {
    return (
        <Layout title="Politics News - Bull & Bear">
            <NewsList category="politics" />
        </Layout>
    )
};

export default Politics;